import { lazy, Suspense, useEffect } from "react";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import { ResizableDivider } from "@/ui/resizable-divider";
import TokenProvider from "./providers/token-provider";
import { TokenInfoHeader } from "./modules/token-info-header";
import BuySellBotTokenProvider from "./providers/buy-sell-token-provider";
import TransactionHistoryFilterProvider from "@providers/token-history-filter/transaction-history-filter-provider";
import { addToHistoryTokens } from "@/utils/token";
import { useParams } from "react-router-dom";
import MyOrdersFilterProvider from "@providers/my-orders-filter/my-orders-filter-provider";
import TopTradersFilterProvider from "@providers/top-traders-filter/top-traders-filter-provider.tsx";
import TradePanel from "./modules/bot-actions/trade-panel";

const GraphSubmodule = lazy(() =>
  import("./modules/graph").then((m) => ({ default: m.GraphSubmodule }))
);

const TransactionsSubmodule = lazy(() =>
  import("./modules/transactions").then((m) => ({
    default: m.TransactionsSubmodule,
  }))
);

const TokenPage = () => {
  const { tokenId } = useParams();

  useEffect(() => {
    if (tokenId) {
      addToHistoryTokens(tokenId);
    }
  }, []);

  return (
    <TokenProvider>
      <TransactionHistoryFilterProvider>
        <TopTradersFilterProvider>
          <MyOrdersFilterProvider>
            <BuySellBotTokenProvider>
              <GradientBorderRadius className="flex-1 flex" overflow>
                <div className="flex w-full">
                  <div className="flex-1 flex">
                    <div className="flex flex-1 flex-col">
                      <TokenInfoHeader />
                      <div className="flex-1">
                        <ResizableDivider
                          topComponent={
                            <Suspense
                              fallback={
                                <div className="w-full h-full p-[0.1rem] animate-pulse bg-gray-800/20"></div>
                              }
                            >
                              <GraphSubmodule />
                            </Suspense>
                          }
                          bottomComponent={
                            <Suspense
                              fallback={
                                <div className="w-full h-full p-[0.1rem] animate-pulse bg-gray-800/20"></div>
                              }
                            >
                              <TransactionsSubmodule />
                            </Suspense>
                          }
                          initialTopHeight={50}
                          minTopHeight={0}
                          maxTopHeight={100}
                        />
                      </div>
                    </div>
                    <div className="flex border-l-[0.063rem] border-border w-[22.063rem] p-[0.625rem] pt-[0.875rem]">
                      <TradePanel />
                    </div>
                  </div>
                </div>
              </GradientBorderRadius>
            </BuySellBotTokenProvider>
          </MyOrdersFilterProvider>
        </TopTradersFilterProvider>
      </TransactionHistoryFilterProvider>
    </TokenProvider>
  );
};

export default TokenPage;
